import { useCallback, useMemo, useRef, useState } from "react";

import { AutocompleteCloseReason } from "@mui/material";

export const useOpenState = () => {
  // Keep track of the open time to prevent the popup from closing
  //  right after the user clicks on the dropdown. This is a workaround
  //  to the limit tag feature bug
  // https://github.com/mui/material-ui/issues/42432;
  const openTime = useRef<number | null>(null);
  const [open, setOpen] = useState(false);
  const onOpen = useCallback(() => {
    setOpen(true);
    openTime.current = Date.now();
  }, []);
  const onClose = useCallback((_event: React.SyntheticEvent, reason: AutocompleteCloseReason) => {
    // Only toggleInput is buggy. Bypass other reasons.
    const now = Date.now();
    if (reason !== "toggleInput" || (openTime.current && now > openTime.current + 500)) {
      setOpen(false);
      openTime.current = null;
      return;
    }
  }, []);

  return useMemo(() => ({ open, onOpen, onClose }), [open, onOpen, onClose]);
};
